import { vModelText as _vModelText, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "has-text-white wrapper"
}
const _hoisted_2 = { class: "input-wrapper mx-auto px-10 is-relative" }
const _hoisted_3 = { class: "is-size-5-mobile is-size-4-tablet medium-text" }
const _hoisted_4 = { class: "medium-text" }
const _hoisted_5 = {
  key: 1,
  class: "is-size-5-mobile is-size-4-tablet medium-text is-underlined has-text-primary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isSelected)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("input", {
            class: "custom-input no-spin-buttons is-size-6-mobile is-size-5-tablet medium-text pb-1 has-text-centered has-background-transparent has-text-white is-shadowless",
            type: "number",
            min: 11,
            max: 999,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.leadsAmount) = $event)),
            placeholder: "Enter a number",
            onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
            onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.debounce && _ctx.debounce(...args))),
            required: ""
          }, null, 544), [
            [_vModelText, _ctx.leadsAmount]
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "input-underline is-overlay" }, null, -1))
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("p", { class: "is-size-6-mobile is-size-5-tablet" }, "for", -1)),
        _createElementVNode("p", _hoisted_3, "$" + _toDisplayString(_ctx.plan.price || '---'), 1),
        _createElementVNode("p", _hoisted_4, "($" + _toDisplayString(!(_ctx.plan.price && _ctx.plan.price_per_lead) ? '--' : _ctx.plan.price_per_lead) + "/lead)", 1)
      ]))
    : (_openBlock(), _createElementBlock("span", _hoisted_5, "10+ Verified Jobs?"))
}